import { useSyncExternalStore } from 'react'

let value: { width: number; height: number } | null = null

function getWindowSize() {
  if (value) {
    return value
  }

  value =
    typeof window !== 'undefined'
      ? {
          width: window.innerWidth,
          height: window.innerHeight,
        }
      : {
          width: 1024,
          height: 768,
        }

  return value
}

/**
 * Returns the width and height of the window.
 *
 * If the window is not available, it will return a default size of 1024x768.
 */
export function useWindowSize() {
  return useSyncExternalStore(
    (change) => {
      const listener = () => {
        value = {
          width: window.innerWidth,
          height: window.innerHeight,
        }

        change()
      }

      window.addEventListener('resize', listener)

      return () => {
        window.removeEventListener('resize', listener)
      }
    },
    () => {
      return getWindowSize()
    },
    () => {
      // We don't need SSR yet, but we could rely on client hints
      // to provide better values here.
      // 1024x768 is a good default for now.
      return {
        width: 1024,
        height: 768,
      }
    },
  )
}
